import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Page from "./Page"
import Notfound from "./Notfound";

const Works = lazy(() => import("./Works"));
const Gallery2 = lazy(() => import("./Gallery2"));

function App() {
  return (
    <div>
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Page />} />
            <Route path="/works" element={<Works />} />
            <Route path="/gallery" element={<Gallery2 />} />
            <Route path="*" element={<Notfound />} />
          </Routes>
        </Suspense>
      </Router>
    </div>

  );
}

export default App;
